<template>
    <BzDialog
        class="patsnap-biz-email_alert__dialog"
        width="600px"
        :title="$t('emailAlertBiz.common.alertDialog.createTitle')"
        :visible="visible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="onCancel"
    >
        <div
            v-show="!loading"
            class="pz-email-alert__body email-alert-dialog"
        >
            <slot
                :service="service"
            />
            <AlertCommonModule
                :service="service"
                :is-all-email-valid="isAllEmailValid"
            >
                <template #wechat>
                    <slot name="wechat" />
                </template>
            </AlertCommonModule>
        </div>
        <div
            v-show="loading"
            class="pz-email-alert__body email-alert-dialog pz-email-alert__loading"
        >
            <Icon
                icon="SolidLoadingBars"
                class="pz-email-alert__loading-icon"
            />
        </div>
        <div
            slot="footer"
            class="pt-email-alert__footer"
        >
            <button
                class="pt-ui-btn"
                size="small"
                @click="onCancel"
            >
                {{ $t('emailAlertBiz.common.alertDialog.cancel') }}
            </button>
            <button
                class="pt-ui-btn"
                size="small"
                type="submit"
                :disabled="submitBtnDisabled"
                @click="onSubmit"
            >
                {{ $t('emailAlertBiz.common.alertDialog.submit') }}
            </button>
        </div>
    </BzDialog>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
/* eslint-disable max-len */
import {
    map, filter, uniq, every, trim,
} from 'lodash';
import BzDialog from '@patsnap-biz/dialog';
import Icon from '@patsnap-biz/icon';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';
import AlertCommonModule from './AlertCommonModule.vue';
import { checkEmail } from '../../utils/index';

export default {
    components: {
        Icon,
        BzDialog,
        AlertCommonModule,
    },
    props: {
        /**
         * 继承 EmailAlertService 的类的实例
         */
        service: {
            type: Object,
            required: true,
            default: () => {},
        },
        /**
         * 是否显示
         */
        visible: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            submitting: false,
        };
    },
    computed: {
        isAllEmailValid() {
            let allOtherEmails;
            // 邮箱拼接，input框里的 + 自动提醒的
            allOtherEmails = map(filter(this.service.selectedEmails, (item) => item.type === 'email'), 'value');
            allOtherEmails = uniq(allOtherEmails);
            return every(allOtherEmails, (email) => checkEmail(email.trim()));
        },
        isSentToOtherTipUnchecked() {
            return !this.shouldSubmit && this.showEmailToOtherTips && !this.sendToOther;
        },
        submitBtnDisabled() {
            return !this.isAllEmailValid
                || this.service.slotSubData === undefined
                || this.service.slotDataError
                || this.loading
                || this.submitting;
        },
        loading() {
            return this.service.innerLoading || this.service.outLoading;
        },
    },
    methods: {
        validateValue(concatEmail, isOnlySendToSelf) {
            if (!this.isAllEmailValid || (trim(this.service.currentInputtingEmail) && !checkEmail(trim(this.service.currentInputtingEmail)))) {
                this.service.onValidationFailed('emailNotCorrect');
                return false;
            }
            if (!concatEmail.length && !this.service.sendToMe) {
                this.service.onValidationFailed('notHasEmail');
                return false;
            }
            if (!isOnlySendToSelf && !this.service.sendToOther) {
                this.service.onValidationFailed('SentToOtherUnchecked');
                this.service.shouldSubmit = false;
                return false;
            }
            this.service.shouldSubmit = true;
            return true;
        },
        onCancel() {
            this.service.onClose(() => {
                this.$emit('update:visible', false);
            });
        },
        async onSubmit() {
            // 如果输入后不触发blur直接点击submit 需要校验input的临时值
            if (!this.validateValue(this.service.concatEmail, this.service.isOnlySendToSelf)) return;
            const otherValidate = this.service.onValidate();
            if (!otherValidate) return;
            this.submitting = true;
            this.$emit('submit', this.service);
            this.service.onSubmit();
            this.submitting = false;
        },
    },
};
</script>
